define('commons/live-search-field',['jquery'], function($) {
    var search = function(settings) {
        var value = '';
        if (typeof settings.data == "undefined") {
            settings.data = {};
        }
        return function() {
            var val = $(this).val();
            if (val != value) {
                value = val;
                settings.data[settings.valueParameter] = val;
                $.ajax({
                    type: settings.type,
                    url: settings.searchUrl,
                    data: settings.data,
                    success: settings.successCallback
                });
            }
        };
    };

    $.fn.liveSearch = function(options) {

        var defaults = {
            searchUrl: "",
            type: 'GET',
            successCallback: null
        };
        $.extend(defaults, options);

        var launchSearch = $.proxy(search(defaults), this);
        var timeout = null;
        this.keyup(function() {
            if (timeout !== null) {
                window.clearTimeout(timeout);
            }
            timeout = window.setTimeout(launchSearch, 300);
        });
        this.click(launchSearch);
    };
});

